<template>
    <section v-if="checkPrice(price.value)" class="calculate-credit-block">
        <div class="wrapper">
            <h2><slot name="section-title">Рассчитайте ипотеку онлайн</slot></h2>
            <div class="calculate-credit-block__container">
                <div class="sliders">
                    <no-ui-slider v-model="price.value" 
                                  title="Стоимость квартиры" 
                                  :min="price.min" :max="price.max" :step="price.step" :start="price.start" 
                                  postfix="руб" 
                                  :view="price.value | threeDigits"></no-ui-slider>
                    <no-ui-slider v-model="deposit.value" ref="deposit"
                                  title="Первоначальный взнос" 
                                  :min="deposit.min" :max="deposit.max" :step="deposit.step" :start="deposit.start" 
                                  postfix="руб" 
                                  :view="deposit.value | threeDigits"></no-ui-slider>
                    <no-ui-slider v-model="time.value" 
                                  title="Срок" 
                                  :min="time.min" :max="time.max" 
                                  :step="time.step" 
                                  :start="time.start" 
                                  postfix="" :view="time.value | russianYears"></no-ui-slider>
                    <no-ui-slider v-model="rate.value" 
                                  title="Ставка" 
                                  :min="rate.min" :max="rate.max" :step="rate.step" :start="rate.start" 
                                  postfix="%" :view="rate.value"></no-ui-slider>
                </div>
               <template>
                 <div class="results">
                   <span class="title"><slot name="results-title">Стоимость квартиры в ипотеку</slot></span>
                   <div class="sum">
                     <p>
                       <span>{{ price.value | threeDigits }} <i class="ruble"></i></span>
                       <small>Общая сумма</small>
                     </p>
                     <p>
                       <span>{{ payment | threeDigits }} <i class="ruble"></i></span>
                       <small><b>ЕЖЕМЕСЯЧНЫЙ ПЛАТЕЖ</b></small>
                     </p>
                   </div>
                   <div class="foot">
                     <button class="button-pill filled" data-modal="#creditPopup">Оставить заявку на квартиру</button>
                     <div class="foot__info">
                       <slot name="caption">
                         <p>Пример расчета процентной ставки носит исключительно информационный характер и не является публичной офертой</p>
                       </slot>
                     </div>
                   </div>
                 </div>
               </template>
            </div>
        </div>
    </section>
</template>

<script>
    import noUiSlider from './NoUiSlider.vue';
    import threeDigits from '../filters/threeDigits';
    import russianCurrency from '../filters/russianCurrency';
    import russianYears from '../filters/russianYears';
    import { PV } from './CreditLogic';
    import { PMT } from './CreditLogic';
    import { checkPrice } from './CreditLogic';

    export default {
        props:['priceStart', 'rateStart'],
        data() {
            return {
                price: {
                    min: parseFloat(this.priceStart) - (parseFloat(this.priceStart) * 0.3),
                    max: parseFloat(this.priceStart) + (parseFloat(this.priceStart) * 0.3),
                    step: 10000,
                    start: this.priceStart,
                    value: this.priceStart
                },
                deposit: {
                    min: parseFloat(this.priceStart) - (parseFloat(this.priceStart) * 0.9),
                    max: parseFloat(this.priceStart) + (parseFloat(this.priceStart) * 0.3),
                    step: 10000,
                    start: parseFloat(this.priceStart) * 0.15,
                    value: parseFloat(this.priceStart) * 0.15
                },
                time: {
                    min: 1,
                    max: 30,
                    step: 1,
                    value: 20
                },
                rate: {
                    min: 4,
                    max: 15,
                    step: 0.1,
                    value: this.rateStart > 0 ? this.rateStart : 9.5
                }
            }
        },
        methods: {
            checkPrice,
            PV,
            PMT
        },
        computed: {
            payment: function () {
                let rate_per_month = this.rate.value / 100 / 12;
                let number_of_payments = this.time.value * 12;
                let credit_sum = this.price.value - this.deposit.value;

                let result = this.PMT(rate_per_month, number_of_payments, -credit_sum);
                result = result > 0 ? result : 0;

                return result;
            },
            minDeposit: function () {
                return this.price.value / 100 * 15;
            },
            avalDeposit() {
                return this.minDeposit - (this.minDeposit % this.deposit.step);
            }
        },
        watch: {
            'price.value'() {
                if (parseFloat(this.deposit.value) < parseFloat(this.avalDeposit)) {
                    this.$refs.deposit.$el.querySelector('.numslider__slider').noUiSlider.set(this.avalDeposit);
                }   

                if (parseFloat(this.deposit.value) > parseFloat(this.price.value)) {
                    this.$refs.deposit.$el.querySelector('.numslider__slider').noUiSlider.set(this.price.value);
                }
            },
            'deposit.value'() {
                if (parseFloat(this.deposit.value) > parseFloat(this.price.value)) {
                    this.$refs.deposit.$el.querySelector('.numslider__slider').noUiSlider.set(this.price.value);
                }   

                if (parseFloat(this.deposit.value) < parseFloat(this.avalDeposit)) {
                    this.$refs.deposit.$el.querySelector('.numslider__slider').noUiSlider.set(this.avalDeposit);
                } 
            }
        },
        components: {
            noUiSlider
        },
        filters: {
            threeDigits,
            russianCurrency,
            russianYears
        }
    }
</script>